// Frank Bundle Live Orders Popup JavaScript
(function() {
  // Array of sample orders
  const orders = [
    { name: "Jean", location: "WI", product: "The Frank Medrano Bundle", time: "19 minutes ago" },
    { name: "Nathaniel", location: "TX", product: "The Frank Medrano Bundle", time: "47 minutes ago" },
    { name: "John", location: "IN", product: "The Frank Medrano Bundle", time: "1 hour 16 minutes ago" },
    { name: "Jason", location: "WA", product: "The Frank Medrano Bundle", time: "1 hour 46 minutes ago" },
    { name: "Michael", location: "TX", product: "The Frank Medrano Bundle", time: "2 hours 17 minutes ago" },
    { name: "Dylan", location: "WA", product: "The Frank Medrano Bundle", time: "2 hours 49 minutes ago" },
    { name: "Rudy", location: "IL", product: "The Frank Medrano Bundle", time: "3 hours 22 minutes ago" },
    { name: "Harvey", location: "KS", product: "The Frank Medrano Bundle", time: "3 hours 56 minutes ago" },
    { name: "Bryan", location: "HI", product: "The Frank Medrano Bundle", time: "4 hours 31 minutes ago" },
    { name: "Saida", location: "FL", product: "The Frank Medrano Bundle", time: "5 hours 7 minutes ago" },
    { name: "Eric", location: "TX", product: "The Frank Medrano Bundle", time: "22 minutes ago" },
    { name: "Ed", location: "CA", product: "The Frank Medrano Bundle", time: "49 minutes ago" },
    { name: "Saida", location: "TX", product: "The Frank Medrano Bundle", time: "1 hour 18 minutes ago" },
    { name: "Raggs", location: "MD", product: "The Frank Medrano Bundle", time: "1 hour 48 minutes ago" },
    { name: "Fausto", location: "OH", product: "The Frank Medrano Bundle", time: "2 hours 19 minutes ago" },
    { name: "John", location: "TN", product: "The Frank Medrano Bundle", time: "2 hours 51 minutes ago" },
    { name: "Greg", location: "NJ", product: "The Frank Medrano Bundle", time: "3 hours 24 minutes ago" },
    { name: "Robert", location: "NY", product: "The Frank Medrano Bundle", time: "3 hours 58 minutes ago" },
    { name: "Will", location: "MA", product: "The Frank Medrano Bundle", time: "4 hours 33 minutes ago" },
    { name: "Salvador", location: "CA", product: "The Frank Medrano Bundle", time: "5 hours 9 minutes ago" },
    { name: "Karen", location: "CA", product: "The Frank Medrano Bundle", time: "5 hours 46 minutes ago" },
    { name: "Carmencita", location: "ID", product: "The Frank Medrano Bundle", time: "6 hours 24 minutes ago" }
  ];

  // Display popup function
  function showLiveOrder() {
    const randomOrder = orders[Math.floor(Math.random() * orders.length)];
    const popup = document.getElementById('live-orders-popup');
    popup.innerHTML = `
      <div class="popup-content">
        <div class="popup-image">
          <img style="border-radius: 5px;" src="https://cdn.shopify.com/s/files/1/2443/2395/files/Frank_Medrano_Bundle_No_Badge.png?v=1733788722" alt="Product Image">
          <span class="glow-dot"></span>
        </div>
        <div class="popup-text">
          <div class="popup-line">
            <div class="name-location"><strong>${randomOrder.name} from ${randomOrder.location}</strong></div>
          </div>
          <div class="popup-line product-name"><span class="ordered-text">ordered</span> <strong><span class="product-text">${randomOrder.product}</span></strong></div>
          <div class="popup-line order-time">${randomOrder.time}</div>
          <div class="verified-buyer-badge">Verified Buyer</div>
        </div>
      </div>
    `;
    popup.style.display = 'block';

    setTimeout(() => {
      popup.classList.add('popup-hide');
    }, 6000); // Show for 5 seconds

    setTimeout(() => {
      popup.style.display = 'none';
      popup.classList.remove('popup-hide');
      setTimeout(showLiveOrder, getRandomTimeInterval());
    }, 6500);
  }

  // Random time intervals between popups
  function getRandomTimeInterval() {
    const intervals = [20000, 20000, 20000]; // 20s, 20s, 20s
    return intervals[Math.floor(Math.random() * intervals.length)];
  }

  // Start the popup display
  document.addEventListener('DOMContentLoaded', () => {
    setTimeout(showLiveOrder, getRandomTimeInterval());
  });
})();
